"use client"
import { create } from "zustand"

interface KeybindModalStore {
  modalOpen: boolean
  setModalOpen: (open: boolean) => void
}

export const useKeybindModalStore = create<KeybindModalStore>(set => ({
  modalOpen: false,
  setModalOpen: open => set({ modalOpen: open }),
}))
